<template>
    <CompassObject
        :object="object"
        size="extra-small"
        :label="titleTypeActivity"
        variant="on-color"
    />
</template>

<script>
export default {
    props: {
        objectType: {
            type: String,
            required: true,
        },
    },
    computed: {
        titleTypeActivity() {
            switch (this.objectType) {
                case 'task':
                    return this.$l10n.__('Tâche');
                case 'phonecall':
                    return this.$l10n.__('Appel');
                case 'event':
                    return this.$l10n.__('Événement');
                default:
                    return '';
            }
        },
        object() {
            switch (this.objectType) {
                case 'task':
                    return 'task';
                case 'event':
                    return 'calendar';
                case 'phonecall':
                    return 'phone';
                default:
                    return null;
            }
        },
    },
};
</script>
